import React, { useState } from "react"
import { Box } from "@infotech/uikit-grid"
import { BackIcon } from "@infotech/uikit-icons"
import get from "lodash/get"
import EventTypeForm from "./Form"
import EventTypeStatusModel from "./Status"
import styles from "./styles.css"

const EventTypeModal = ({
  isNew,
  eventType,
  resourceTypeList,
  id,
  backToList,
  disableCreate,
  disableEdit,
  create,
  update,
  actionStatus,
  statusModelPermission,
}) => {
  const disableForm = isNew ? disableCreate : disableEdit
  const waitData = isNew ? true : get(eventType, `status.completed`)
  const [showErrors, makeShowErrors] = useState(false)
  return (
    <Box loose>
      <Box loose className={styles.EventTypeWrapper} flex column>
        <Box
          loose
          className={styles.EventTypeHeader}
          flex
          row
          pl="21px"
          pt="2md"
          pb="2md"
        >
          <Box loose className={styles.BackIcon} onClick={backToList}>
            <BackIcon color="#627d98" />
          </Box>
          <Box loose className={styles.EventTypeHeaderText} pt="2px" pl="1md">
            {isNew ? `Создание` : `Редактирование`} типа события
          </Box>
        </Box>
        <Box loose flex row>
          {waitData && (
            <EventTypeForm
              isNew={isNew}
              showErrors={showErrors}
              makeShowErrors={makeShowErrors}
              backToList={backToList}
              disableForm={disableForm}
              eventType={eventType}
              resourceTypeList={resourceTypeList}
              create={create}
              update={update}
              actionStatus={actionStatus}
            />
          )}
          <Box loose className={styles.Rectangle} />
          <Box loose className={styles.EventTypeStatusAdmin}>
            <EventTypeStatusModel
              resourceTypeList={resourceTypeList}
              statusModelPermission={statusModelPermission}
              id={id}
              isNew={isNew}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EventTypeModal
